<template>
  <div class="container p-5">
    <!-- Modal -->
    <div class="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true" >
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title text-danger" id="exampleModalLabel">{{ $t('main.congratulations') }}</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Zamknij"></button>
          </div>
          <div class="modal-body">
            <p class="text-start">{{ $t("result.guessed") }}: <b>{{fullform}}</b> - {{translation}}. <br/>
              {{ $t("result.variations") }}: {{variations}} <br>
              {{ $t("result.example") }}: {{example}}
            </p>
            <p class="text-start">
              {{ $t("result.thanks") }}

            </p>
            <div class="input-group mb-3" v-if="!signedNewsletter">
              <input type="email" v-model="email" class="form-control" :placeholder="$t('result.your-email')" aria-label="Email" aria-describedby="basic-addon1" :disabled="disableNewsletter">
              <button type="button" class="btn btn-primary" @click="newsletter" :disabled="disableNewsletter"> {{ $t("result.signin") }}</button>
            </div>
            <h5 v-if="signedNewsletter">{{ $t("result.signed") }}</h5>
            <h5 v-if="emailError" class="alert-danger">{{ $t("result.invalidemail") }}</h5>

            <h5>{{ $t("result.share") }}</h5>
            <div class="row">
            <div class="card col-6 p-1">
              <div class="card-body">
                <ShareNetwork
                    network="facebook"
                    :url="$t('result.shareUrl')"
                    :title="$t('result.shareTitle')"
                    :description="$t('result.shareDescription')"
                >
                  <i class="bi-facebook"></i>
                  <span>Facebook</span>
                </ShareNetwork>
              </div>
            </div>

            <div class="card col-6 p-1">
              <div class="card-body">
              <ShareNetwork
                  network="messenger"
                  :url="$t('result.shareUrl')"
              >
                <i class="bi-messenger"></i>
                <span>Messenger</span>
              </ShareNetwork>
              </div>
            </div>
            </div>
            <div class="row mt-4">
              <div class="col-2"></div>
              <div class="col-8">
                <a :href="$t('common.coursesLink')" target="_blank" class="btn btn-primary">{{ $t('common.coursesRead') }}</a>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-primary" data-bs-dismiss="modal">{{ $t("common.close") }}</button>
          </div>
        </div>
      </div>

    </div>

  </div>
</template>

<script>
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.min.js";
import {Modal} from "bootstrap";
import axios from "axios";

export default {
  name: "Modal",
  props: {
    word: {
      type: String,
      default: ""
    },
    translation: {
      type: String,
      default: ""
    },
    description: {
      type: String,
      default: ""
    },
    fullform: {
      type: String,
      default: ""
    },
    example: {
      type: String,
      default: ""
    },
    variations: {
      type: String,
      default: ""
    },
  },
  mounted() {
    console.log(document.getElementById('exampleModal'));
    this.modalObj  = new Modal(document.getElementById('exampleModal'))
  },
  data() {
      return {
        showModal: false,
        modalObj:null,
        disableNewsletter:false,
        signedNewsletter:false,
        email:"",
        emailError:false
      }
  },
  methods:{
    show(){
      this.modalObj.show();
    },
    newsletter(event){
      this.disableNewsletter = true;
      this.emailError = false;
      axios
          .post(
              "https://api1.puffli.no/newsletter/subscribe",
              {
                email: this.email,
                subscription_types: ["daily_word"]
              }
          )
          .then((res) => {
            if(res.data.info === "ok"){
              this.signedNewsletter = true;
            } else {
              this.emailError = true;
              this.disableNewsletter = false;
            }
          })
          .catch((err) => {
            console.log(err.response);
            this.emailError = true;
            this.disableNewsletter = false;
          });
    }
  }
}
</script>
<style  scoped>
.card{
  font-size:24px;
}
.card i{
  margin-right: 10px;
}
</style>